export default __webpack_public_path__ + "static/Stakeholder briefing - March 2021-c0c8b6061106d94c9885e84cb34ab821.pdf";